import KnowsHowMuchToInvestOptionsApi from '../../../core/api/KnowsHowMuchToInvestOptionsApi'
export const FETCH_KNOWS_HOW_MUCH_TO_INVEST_OPTIONS = 'FETCH_KNOWS_HOW_MUCH_TO_INVEST_OPTIONS'
export const FETCHING_KNOWS_HOW_MUCH_TO_INVEST_OPTIONS = 'FETCHING_KNOWS_HOW_MUCH_TO_INVEST_OPTIONS'
export const CLEAR_INVESTMENT_AMOUNT_CONTAINER = 'CLEAR_INVESTMENT_AMOUNT_CONTAINER'

export const fetchingKnowsHowMuchToInvestOptions = () => ({
  type: FETCHING_KNOWS_HOW_MUCH_TO_INVEST_OPTIONS
})

export function fetchKnowsHowMuchToInvestOptions () {
  const api = new KnowsHowMuchToInvestOptionsApi()
  
  return async (dispatch) => {
    try{
      const response = await api.fetchingKnowsHowMuchToInvestOptions()
      dispatch({
        type: FETCH_KNOWS_HOW_MUCH_TO_INVEST_OPTIONS,
        payload: response
      })
      return response
    } catch(error) {
      dispatch({
        type: FETCH_KNOWS_HOW_MUCH_TO_INVEST_OPTIONS,
        payload: []
      })
      throw error
    }
  }
}
